const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const pad = (value: number): string => String(value).padStart(2, '0')

const parts = (iso: string): [number, number, number] => {
    const [year, month, day] = iso.split('-').map(Number)

    return [year, month || 1, day || 1]
}

export const monthName = (monthIndex: number): string => MONTHS[monthIndex] ?? ''

/** "2025-02-07" becomes "Feb 7, 2025". Deterministic on server and client. */
export const formatShortDate = (iso: string): string => {
    const [year, month, day] = parts(iso)

    return `${MONTHS[month - 1].slice(0, 3)} ${day}, ${year}`
}

/** "2025-02" (or a full date) becomes "Feb 2025". */
export const formatMonthShort = (iso: string): string => {
    const [year, month] = parts(iso)

    return `${MONTHS[month - 1].slice(0, 3)} ${year}`
}

/** "2026-11-14" becomes "Saturday 14 November 2026". */
export const formatLongDate = (iso: string): string => {
    const [year, month, day] = parts(iso)
    const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay()

    return `${WEEKDAYS[weekday]} ${day} ${MONTHS[month - 1]} ${year}`
}

/** "2026-11-01" or "2026-11" becomes "November 2026". */
export const formatMonthYear = (iso: string): string => {
    const [year, month] = parts(iso)

    return `${MONTHS[month - 1]} ${year}`
}

export const toISODate = (year: number, monthIndex: number, day: number): string => `${year}-${pad(monthIndex + 1)}-${pad(day)}`

export const toMonthKey = (year: number, monthIndex: number): string => `${year}-${pad(monthIndex + 1)}`

export const daysInMonth = (year: number, monthIndex: number): number => new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate()
